import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import AddCircleOutline from '@material-ui/icons/AddCircleOutline';
import { observer } from 'mobx-react';

import { translate } from 'services/i18nService';
import CompanionAdService from 'services/adServices/CompanionAdService';
import { noOp } from 'utils/helpers';

import styles from './index.css';


@observer
class CompanionAd extends PureComponent {
  static propTypes = {
    wrapperClassName: PropTypes.string,
    onClick: PropTypes.func,
  };

  static defaultProps = {
    wrapperClassName: undefined,
    onClick: noOp,
  };

  componentDidMount() {
    if (document.hasFocus()) {
      CompanionAdService.triggerAd();
    } else {
      window.addEventListener('focus', this.onWindowFocused);
    }
  }

  componentDidUpdate() {
    if (this.containerRef) {
      const { containerLoaded } = CompanionAdService;

      window.addEventListener('blur', this.inferIframeClick);
      containerLoaded(this.containerRef);
    }
  }

  componentWillUnmount() {
    CompanionAdService.cancelExistingAd();

    window.removeEventListener('blur', this.inferIframeClick);
    window.removeEventListener('focus', this.onWindowFocused);
  }

  setIframeRef = (iframe) => {
    this.iframeRef = iframe;
  };

  setContainerRef = (container) => {
    this.containerRef = container;
  };

  inferIframeClick = () => {
    if (
      document.activeElement?.nodeName.toLowerCase() === 'iframe' &&
      this.iframeRef === document.activeElement
    ) {
      this.onIframeClick();
    }
  };

  onWindowFocused = () => {
    CompanionAdService.triggerAd();
    window.removeEventListener('focus', this.onWindowFocused);
  };

  onIframeClick = () => {
    const { clickAd } = CompanionAdService;
    clickAd();

    this.props.onClick();
  };

  onClose = () => {
    const { cancelExistingAd } = CompanionAdService;

    cancelExistingAd();
  };

  render() {
    const {
      getAdDetails,
      isAdVisible,
    } = CompanionAdService;

    if (!isAdVisible) {
      return null;
    }

    const options = getAdDetails();
    if (!options) {
      return null;
    }

    const { wrapperClassName } = this.props;
    const { id, url } = options;

    return (
      <div
        ref={this.setContainerRef}
        className={wrapperClassName}
      >
        <AddCircleOutline
          className={styles.closeButton}
          onClick={this.onClose}
        />
        <div id={`adn-${id}`}>
          <iframe
            ref={this.setIframeRef}
            className={styles.iframe}
            data-zone={id}
            height={100}
            sandbox="allow-popups allow-scripts allow-same-origin allow-forms"
            scrolling="no"
            src={url}
            title={translate('menuoptions.Remove.these.Ads')}
            width={300}
          />
        </div>
      </div>
    );
  }
}

export default CompanionAd;
